import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';
import { submit as submitAnswers } from '../../api/SurveyApi';

const SurveySubmit = ({ onSubmit }) => {
  const { t } = useTranslation('commons');
  const history = useHistory();
  const { token } = useParams();
  const [submitting, setSubmitting] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const answers = useSelector(state => state.answers);
  const questions = useSelector(state => state.questions);
  const questionsCount = Object.keys(questions).reduce((total, k) => total + questions[k].length, 0);
  const answersCount = Object.keys(answers).length;
  const submitHandler = () => {
    if (answersCount < questionsCount) {
      setConfirmModal(true);
    } else {
      submit();
    }
  };
  const submit = async () => {
    setSubmitting(true);
    try {
      await submitAnswers(token, answers);
    } catch (e) {
      toast.error(e.message);
      return setSubmitting(false);
    }
    history.push('/seca/completed');
  };
  const handleModalClose = () => setConfirmModal(false);
  return (
    <div className="d-inline-block">
      <button
        className="btn btn-primary"
        onClick={submitHandler}
        disabled={submitting}
      >
        {t('navigation.submit')}
      </button>
      <Modal show={confirmModal} onHide={handleModalClose}>
        <Modal.Body>
          <h5><strong>{t('incompleteSurvey.header')}</strong></h5>
          <p>{t('incompleteSurvey.subtitle')}:</p>
          <ol>
            <li>{t('incompleteSurvey.option1')}</li>
            <li>{t('incompleteSurvey.option2')}</li>
          </ol>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleModalClose}>{t('navigation.back')}</Button>
          <Button variant="primary" onClick={submit} disabled={submitting}>{t('navigation.submit')}</Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer
        position="bottom-center"
      />
    </div>
  );
};

export default SurveySubmit;
